import { SET_MAP_ZOOM } from "../../../Actions/Types";
import { IMapMarker } from "../Models/IMapMarker";
import {
    SetLoadingOverlay,
    SetMapCenterAction,
    SetMapMarkersAction,
    SetMapZoomAction,
    SET_LOADING_OVERLAY,
    SET_MAP_CENTER,
    SET_MAP_MARKERS_NEW,
} from "../Types/MapActionTypes";

/** misc */
export const setMapMarkers = (markers: IMapMarker[]): SetMapMarkersAction => ({
    type: SET_MAP_MARKERS_NEW,
    data: markers,
});

export const setShowLoadingOverlay = (loading: boolean): SetLoadingOverlay => ({
    type: SET_LOADING_OVERLAY,
    data: loading,
});

export const setMapCenter = (center: google.maps.LatLng): SetMapCenterAction => ({
    type: SET_MAP_CENTER,
    data: center,
});

export const setMapZoom = (zoom: number): SetMapZoomAction => ({
    type: SET_MAP_ZOOM,
    data: zoom,
});
